import DefaultPatient from 'assets/images/defaultPatient.svg';
import { twMerge } from 'tailwind-merge';
import { useState } from 'react';
type Size =
  | 'xs'
  | 'sm'
  | 'sm_s'
  | 'sm_md'
  | 'sm_lg'
  | 'sm_xl'
  | 's'
  | 'md'
  | 'lg'
  | 'xl';
interface AvatarProps {
  imageUrl?: string | null;
  size: Size;
  customClasses?: string;
  defaultAvatar?: string;
  children?: React.ReactNode | null;
}

const SizeOption = {
  xs: 'h-6 min-w-[1.5rem] w-6',
  sm: 'h-[44px] min-w-[44px] w-[44px]',
  sm_s: 'h-[48px] w-[48px] min-w-[48px]',
  sm_md: 'h-[52px] w-[52px] min-w-[52px]',
  sm_lg: 'h-[60px] w-[60px] min-w-[60px]',
  sm_xl: 'h-[72px] w-[72px] min-w-[72px]',
  s: 'h-20 w-20 min-w-20',
  md: 'h-[106px] w-[106px]',
  lg: 'h-40 w-40 min-w-40',
  xl: 'h-[192px] w-[192px] min-w-[192px]',
};

const getSizeClasses = (size: Size): string => {
  return SizeOption[size] || SizeOption.sm;
};

const Avatar: React.FC<AvatarProps> = ({
  imageUrl,
  size,
  customClasses,
  defaultAvatar = DefaultPatient,
}) => {
  const baseClasses = 'rounded-[200px]';

  const [imgSrc, setImgSrc] = useState(() => imageUrl || defaultAvatar);

  const handleError = () => {
    if (!imageUrl) return;
    setImgSrc(DefaultPatient);
  };

  return (
    <img
      className={twMerge(
        `${baseClasses} ${getSizeClasses(size)} object-cover`,
        customClasses,
      )}
      onError={handleError}
      src={imgSrc}
      crossOrigin="use-credentials"
      alt="Avatar"
    />
  );
};

export default Avatar;
